import {BrowserModule} from '@angular/platform-browser';
import {NgModule, Injectable} from '@angular/core';
import {Angular2FontawesomeModule} from 'angular2-fontawesome/angular2-fontawesome'
import {AppComponent} from './app.component';
import {NavbarComponent} from './component/navbar/navbar.component';
import {SidebarComponent} from './component/sidebar/sidebar.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HomeComponent} from './component/home/home.component';
import {CashBookComponent} from './component/cash-book/create/cash-book.component';
import {P404ComponentComponent} from './component/p404-component/p404-component.component';
import {AppLayoutComponent} from './layout/app-layout/app-layout.component';
import {LoginComponent} from './component/login/login.component';
import {appRoutingProviders, routing} from "./app.routes";
import {HttpModule} from '@angular/http';
import {RegisterComponent} from './component/register/register.component';
import {AlertComponent} from './component/alert/alert.component';
import {AlertService} from "./services/alert.service";
import {PrintService} from "./services/print.service";
import {UserService} from "./services/user.service";
import {AuthenticationService} from "./services/authentication.service";
import {CashBookingService} from "./services/cash-booking.service";
import {CashBookListComponent} from './component/cash-book/cash-book-list/cash-book-list.component';
import {LoaderComponent} from './component/loader/loader.component';
import {LoaderService} from "./services/loader.service";
import {SettingsComponent} from './component/settings/settings.component';
import {WebviewDirective} from './directives/webview.directive';
import {SettingsService} from "./services/settings.service";
import {CashBookingPrintComponent} from "./component/cash-book/cash-booking-print/cash-booking-print.component";
import {RateCalculatorComponent} from './component/rate-calculator/rate-calculator.component';
import {Ng2CompleterModule} from "ng2-completer";
import {AccountBookingComponent} from './component/account-booking/account-booking/account-booking.component';
import {AccountBookingListComponent} from './component/account-booking/account-booking-list/account-booking-list.component';
import {AccountBookingService} from "./services/account-booking.service";
import { AccountsComponent } from './component/accounts/accounts/accounts.component';
import { AccountsListComponent } from './component/accounts/accounts-list/accounts-list.component';
import {AccountsService} from "./services/accounts.service";
import { AccountBookingPrintComponent } from './component/account-booking/account-booking-print/account-booking-print.component';
import { DepositComponent } from './component/deposit/deposit.component';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    SidebarComponent,
    HomeComponent,
    CashBookComponent,
    P404ComponentComponent,
    AppLayoutComponent,
    LoginComponent,
    RegisterComponent,
    AlertComponent,
    CashBookListComponent,
    LoaderComponent,
    SettingsComponent,
    WebviewDirective,
    CashBookingPrintComponent,
    RateCalculatorComponent,
    AccountBookingComponent,
    AccountBookingListComponent,
    AccountsComponent,
    AccountsListComponent,
    AccountBookingPrintComponent,
    DepositComponent
  ],
  imports: [
    routing,
    BrowserModule,
    Angular2FontawesomeModule,
    HttpModule,
    FormsModule,
    ReactiveFormsModule,
    Ng2CompleterModule,
    NgbModule.forRoot()
  ],
  providers: [
    appRoutingProviders,
    AlertService,
    AuthenticationService,
    UserService,
    AccountBookingService,
    AccountsService,
    CashBookingService,
    LoaderService,
    PrintService,
    SettingsService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// /root/production/sne-pro/src/app/app.module.ts